(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function breekGetProductCard(item) {
    return (
      item.querySelector('product-card') ||
      item.querySelector('.product-grid__card') ||
      item.querySelector('.product-card') ||
      item.querySelector('.card') ||
      item
    );
  }

  function breekGetMediaBlock(card) {
    const directMedia =
      card.querySelector('.card-gallery') ||
      card.querySelector('.product-card__media') ||
      card.querySelector('.product-card__image') ||
      card.querySelector('.card__media') ||
      card.querySelector('[data-product-media]') ||
      card.querySelector('.media');

    if (directMedia) return directMedia;

    const firstImage = card.querySelector('img');
    if (!firstImage) return null;

    return firstImage.closest('a') || firstImage.parentElement;
  }

  function breekGetTitleBlock(item) {
    const title =
      item.querySelector('.product-title') ||
      item.querySelector('.product-card__title') ||
      item.querySelector('.card__heading') ||
      item.querySelector('.card-information__text') ||
      item.querySelector('[data-product-title]') ||
      item.querySelector('h3') ||
      item.querySelector('h2');

    if (title) return title;

    return Array.from(item.querySelectorAll('a[href*="/products/"]')).find((link) => {
      return link.textContent.trim().length > 0 && !link.querySelector('img') && !link.closest('.bc-metal-variants');
    });
  }

  function breekGetPriceBlock(card) {
    return (
      card.querySelector('[data-product-price]') ||
      card.querySelector('product-price') ||
      card.querySelector('.price') ||
      card.querySelector('.product-card__price') ||
      card.querySelector('.card-information__price')
    );
  }

  function breekMountCardExtras() {
    document.querySelectorAll('.product-grid__item').forEach((item) => {
      const card = breekGetProductCard(item);
      const media = breekGetMediaBlock(card);
      const title = breekGetTitleBlock(item);
      const swatches = item.querySelector('.bc-metal-variants');

      if (swatches) {
        if (media && media.parentElement && swatches.previousElementSibling !== media) {
          media.insertAdjacentElement('afterend', swatches);
        } else if (!media && title && swatches.nextElementSibling !== title) {
          title.insertAdjacentElement('beforebegin', swatches);
        } else if (!media && !title) {
          card.appendChild(swatches);
        }

        swatches.classList.add('is-mounted');
      }

      // Cache the card's original (range) price markup once, so we always have
      // something to fall back on and never destroy the source of truth.
      const priceBlock = breekGetPriceBlock(card);
      if (priceBlock && !priceBlock.dataset.bcOriginalPriceHtml) {
        priceBlock.dataset.bcOriginalPriceHtml = priceBlock.innerHTML;
      }
    });
  }

  function breekUpdateProductCardImage(item, swatch) {
    const imageUrl = swatch.dataset.variantImage;
    const variantUrl = swatch.dataset.variantUrl;
    const variantAlt = swatch.dataset.variantAlt;
    const card = breekGetProductCard(item);

    if (imageUrl) {
      const primaryImage = Array.from(card.querySelectorAll('img')).find((image) => {
        return !image.closest('.bc-metal-variants');
      });

      if (primaryImage) {
        const picture = primaryImage.closest('picture');

        if (picture) {
          picture.querySelectorAll('source').forEach((source) => {
            source.removeAttribute('srcset');
            source.removeAttribute('data-srcset');
          });
        }

        primaryImage.removeAttribute('srcset');
        primaryImage.removeAttribute('data-srcset');
        primaryImage.removeAttribute('data-src');
        primaryImage.src = imageUrl;

        if (variantAlt) {
          primaryImage.alt = variantAlt;
        }
      }
    }

    if (variantUrl) {
      card.querySelectorAll('a[href*="/products/"]').forEach((link) => {
        if (!link.closest('.bc-metal-variants')) {
          link.href = variantUrl;
        }
      });
    }
  }

  function breekUpdateProductCardPrice(item, swatch) {
    const card = breekGetProductCard(item);
    const priceBlock = breekGetPriceBlock(card);
    if (!priceBlock) return;

    const variantPrice = swatch.dataset.variantPrice;
    if (!variantPrice) return;

    const compareAtPrice = swatch.dataset.variantCompareAtPrice;

    // Try to reuse the theme's own price-item markup so styling (sale colors,
    // strike-through, etc.) is preserved. Falls back to a plain text swap.
    const saleItem = priceBlock.querySelector('.price-item--sale');
    const regularItem = priceBlock.querySelector('.price-item--regular');

    if (saleItem || regularItem) {
      if (compareAtPrice) {
        priceBlock.classList.remove('price--no-sale');
        priceBlock.classList.add('price--sale');

        if (saleItem) {
          saleItem.textContent = variantPrice;
          saleItem.hidden = false;
        }
        if (regularItem) {
          regularItem.textContent = compareAtPrice;
          regularItem.classList.add('price-item--sale-compare');
        }
      } else {
        priceBlock.classList.remove('price--sale');
        priceBlock.classList.add('price--no-sale');

        if (saleItem) {
          saleItem.hidden = true;
        }
        if (regularItem) {
          regularItem.textContent = variantPrice;
          regularItem.classList.remove('price-item--sale-compare');
        } else {
          priceBlock.textContent = variantPrice;
        }
      }
    } else {
      // No recognizable price-item structure — just replace the visible text.
      priceBlock.textContent = compareAtPrice
        ? `${variantPrice} ${compareAtPrice}`
        : variantPrice;
    }

    priceBlock.dataset.bcVariantSelected = 'true';
  }

  function breekBindMetalSwatches() {
    document.addEventListener('click', (event) => {
      const swatch = event.target.closest('.bc-metal-swatch');
      if (!swatch) return;

      event.preventDefault();
      event.stopPropagation();

      const item = swatch.closest('.product-grid__item');
      if (!item) return;

      item.querySelectorAll('.bc-metal-swatch').forEach((otherSwatch) => {
        otherSwatch.classList.remove('is-selected');
      });

      swatch.classList.add('is-selected');
      breekUpdateProductCardImage(item, swatch);
      breekUpdateProductCardPrice(item, swatch);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    breekMountCardExtras();
    breekBindMetalSwatches();

    const observer = new MutationObserver(() => {
      breekMountCardExtras();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  document.addEventListener('shopify:section:load', () => {
    breekMountCardExtras();
  });

  } catch(e) { console.error(e); }
})();
})();
